<template>
  <v-row>
    <v-radio-group
      
      :value="value"
      row
      :rules="rules"
      :label="label"
      @change="onChanging"
      :readonly="readonly"
    >
      <template #label v-if="required">
        <span class="red-error"><strong>* </strong></span>{{ label }}
      </template>
      <template v-for="item in items">
        <v-radio
          :key="item.itemValue"
          :label="item.itemText"
          :value="item.itemValue"
        ></v-radio>
      </template>
    </v-radio-group>
  </v-row>
</template>

<script lang="ts">
import { ISelectItem } from "@/models/select-item";
import { ConsoleLog, Timeout } from "@/utility";
import Vue from "vue";

export default Vue.extend({
  props: {
    value: String || Number,
    label: String,
    items: [],
    rules: [],
    required: Boolean,
    readonly: { type: Boolean, default: false },
    showAsLabel: { type: Boolean, default: false },
  },
  data: () => ({
    selectedValue: null,
  }),
  computed: {},
  methods: {
    ConsoleLog,
    onChanging(value: string): void {
      // ConsoleLog({ "FormRadioGroup.onChanging": value });
      this.$emit("input", value);
      this.$emit("userChange", value);
    },
    userChange2(value: any) {
      // ConsoleLog({ "FormRadioGroup.onUserChanging": value });
      this.$emit("userChange", value);
    },
  },
  mounted(): void {
    const self = this as any;
    if (self.value) {
      self.selectedValue = self.value;
    }
    // ConsoleLog({ "FormRadioGroup.items": self.items });
  },
});
</script>
